const capitalLetters = /[^A-Z]+/g;
const spaces = /\s/g;
const email = /[^@\s]+@([^@\s]+\.)+[^@\s]+/g;

export const regex = {
  capitalLetters,
  spaces,
  email
};
